import api from './axiosConfig';

export const getCurrentSubscriptions = async (orgId: string) => {
  try {
    const response = await api({
      method: 'get',
      url: `/v2/organization/${orgId}/subscriptions`,
    });
    return response.data;
  } catch (e) {
    console.error(e);
    return [];
  }
};
